import { Box } from "@mui/material";
import BookmarkPlan from "components/common/Bookmark";
import Feedback from "components/common/Feedback";
import BasicTable from "components/common/Table";
import PlanAssignment from "components/features/PlanAssignment";
import { getUserDetails } from "components/features/SME/sme.slice";
import { useTranslate } from "hooks/useTranslate";
import { cloneDeep, isUndefined } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import {
  ABOVE_PROP_USER_TYPE,
  DEFAULT_CORP_INNCODE,
  FEEDBACK_TIMER,
  abovePropertyViewTypeProperty,
  corpViewTypes
} from "utils/CommonConstants";
import {
  decrypt,
  getAllMapedIdAndUsers,
  getKeyMetricsPropertiesData,
  getKeyMetricsPropertiesDataForSc,
  getTableColor,
  getplanSourceCount,
  setExtractMemberList
} from "utils/CommonFunctions";
import { responseTypes } from "utils/Types";
import {
  addMemberToList,
  fetchCorpDashboardPropertiesAsync,
  fetchCorpDashboardPropertiesOverviewAsync,
  fetchIndividualPropertyAsync,
  reset,
  setPropertiesListRedux
} from "../../Corp/CorpUser.Slice";
import MapUserToInnCode from "../AddUser";
import { getAllBreakupLists, getmyListType } from "../MyLists";
import "./ListDataView.scss";
import { useFilterRequestPayload } from "./ListDataViewHelper";
import ListKeyMetrics from "./ListKeyMetrics";
import {
  PAGE_SIZE,
  appendViewAndMyListFields,
  getBrandOrInitPlanCountStatus,
  getImplementedPlanCount,
  getPropertyName,
  getRowsForSc,
  updateSelectedMappingIds
} from "./PropertiesDataHelper";
import TableEdit from "./TableEdit";
import { dashboardPropertiesHeaders, propertiesHeaders, scPropertiesHeaders } from "./TableHeadersConfig";

interface SelectedListInterface {
  id: number;
  hltId: string;
  innCode: string;
}

const PropertiesData = ({ view, selectedListType, selectedList }: any) => {
  const [pageNo, setPageNo] = useState(0);
  const [propertiesDataState, setPropertiesData] = useState<any>([]);
  const [multiplansAssign, setMultiplansAssign] = useState<boolean>(false);
  const [selectAllProperties, setSelectAllProperties] = useState<boolean>(false);
  const [assignees, setAssignees] = useState<string[] | []>([]);
  const [allTeamMember, setAllTeamMember] = useState<any | []>([]);
  const [isAddUserVisible, setIsAddUserVisible] = useState<{
    isVisible: boolean;
    selectedInnCode: string;
    row: any;
    index: number;
  }>({
    isVisible: false,
    selectedInnCode: "",
    row: null,
    index: -1
  });
  const [checkInncodeUser, setCheckInncodeUser] = useState({
    shouldShow: false,
    variant: "error",
    timer: FEEDBACK_TIMER
  });
  const [unCheckedMappings, setUnCheckedMappings] = useState<any>([]);
  const lobbyUserType = decrypt("salt", localStorage.getItem("lobbyUserType"));
  const propertiesList = useAppSelector((state) => state.CorpDashboard.myView.properties.list);
  const totalRecords = useAppSelector((state) => state.CorpDashboard.myView.properties.totalRecords);
  const { dynamicSelectFlag, filterRequestPayload, formattedFilterRequestPayload } = useFilterRequestPayload(
    view,
    selectedListType
  );

  const overview = useAppSelector((state) => state.CorpDashboard.myView.properties.overview);
  const bookmarkedProperties = useAppSelector((state) => state.aboveProperty.bookmarkedProperties);
  const listCategory = useAppSelector((state) => state.CorpDashboard.myListsSelected.listCategory);

  const tableName = "propertiesSort_" + view;
  const sorting = useAppSelector((state) => state.sortingDetails.sorting);
  const recentSortingApplied = sorting?.[tableName];
  const searchedText = useAppSelector((state) => state.CorpDashboard.searchText?.[view]);

  const dispatch = useAppDispatch();
  const [ids, setId] = useState(null);
  const navigate = useNavigate();
  const translate = useTranslate();

  const myListType = getmyListType(selectedListType, selectedList?.name);

  const handleSetCheckInncodeUser = (isShow: boolean) => {
    setCheckInncodeUser({ shouldShow: isShow, variant: "error", timer: FEEDBACK_TIMER });
  };

  const fetchIndividualProperty = async (row: any, index: number) => {
    if (!row.history.length) {
      const clonedFilter = cloneDeep(formattedFilterRequestPayload);
      const clonedPropertiesDataState = cloneDeep(propertiesDataState);
      clonedFilter.inncode = [row.inncode];
      const payloadData = appendViewAndMyListFields(clonedFilter, view, myListType, selectedList?.id);

      const res = await dispatch(
        fetchIndividualPropertyAsync({
          ...payloadData,
          pageable: { page: pageNo, size: PAGE_SIZE }
        })
      );

      clonedPropertiesDataState[index].apiCaled = true;
      if (res.payload?.mappings) {
        const mappings = res.payload?.mappings?.map((child: any) => ({
          ...child,
          isChecked: row.isChecked
        }));
        clonedPropertiesDataState[index].history = isUndefined(clonedPropertiesDataState[index].history)
          ? mappings
          : [...clonedPropertiesDataState[index].history, ...mappings];
      }
      dispatch(setPropertiesListRedux(clonedPropertiesDataState));
    }
  };

  const fetchSummaryAndOverview = async (
    pageNo: number = 0,
    searchText: string = searchedText,
    callOverview: boolean = true
  ) => {
    const payloadData = appendViewAndMyListFields(
      { ...formattedFilterRequestPayload, ...dynamicSelectFlag, sort: { ...recentSortingApplied } },
      view,
      myListType,
      selectedList?.id
    );
    if (callOverview)
      dispatch(
        fetchCorpDashboardPropertiesOverviewAsync({
          ...payloadData
        })
      );
    const idCheck = view === corpViewTypes.myList && listCategory !== "bookmarked" ? selectedList?.id : true;
    if (idCheck) {
      const response = await dispatch(
        fetchCorpDashboardPropertiesAsync({
          ...payloadData,
          pageable: { page: pageNo, size: PAGE_SIZE },
          searchText
        })
      );

      const mappedHltIds = response?.payload?.meta?.mappedHltIds;
      if (mappedHltIds?.length && listCategory === "consultant") {
        const userDetails = await dispatch(getUserDetails(mappedHltIds));
        setAllTeamMember(userDetails?.payload?.users || []);
      }
    }
  };

  const isMountedRef = useRef(false);
  const prevFilterRef = useRef(filterRequestPayload);
  useEffect(() => {
    if (String(lobbyUserType).toLowerCase() === ABOVE_PROP_USER_TYPE) return;

    const filterChanged = !isMountedRef.current || prevFilterRef.current !== filterRequestPayload;
    isMountedRef.current = true;
    prevFilterRef.current = filterRequestPayload;

    fetchSummaryAndOverview(0, searchedText, filterChanged);
    setPageNo(0);
  }, [filterRequestPayload, recentSortingApplied]);

  const handleUserVisible = (data: any) => {
    const userData = {
      isVisible: data.isVisible,
      index: data.index,
      row: data.row,
      selectedInnCode: data.row?.innCode
    };
    const assignedData: string[] = [];
    data.row?.history?.map((history: any) => {
      if (history?.hltId) {
        assignedData.push(history.hltId);
      }
    });
    setAssignees(assignedData);

    setIsAddUserVisible(userData);
  };

  useEffect(() => {
    if (pageNo > 0) {
      fetchSummaryAndOverview(pageNo, searchedText, false);
    }
  }, [pageNo]);

  const handleSelectedAllScProperty = (e: any) => {
    const isChecked = e.target.checked;
    if (isChecked) setUnCheckedMappings([]);
    const clonedPropertiesDataState = cloneDeep(propertiesDataState);
    const newParents = clonedPropertiesDataState.map((parent: any) => ({
      ...parent,
      isChecked: !parent.inncodeMappingUserName ? false : !selectAllProperties,
      history: parent.history?.map((child: any) => ({
        ...child,
        isChecked: !selectAllProperties
      }))
    }));
    dispatch(setPropertiesListRedux(newParents));
    setSelectAllProperties(!selectAllProperties);
  };

  const handleParentChange = (e: any, parent: any, index: number) => {
    const checked = e.target.checked;
    const clonedPropertiesDataState = cloneDeep(propertiesDataState);
    clonedPropertiesDataState[index].isChecked = checked;
    if (clonedPropertiesDataState[index].history) {
      clonedPropertiesDataState[index].history = clonedPropertiesDataState[index].history.map((child: any) => ({
        ...child,
        isChecked: checked
      }));
    }

    dispatch(setPropertiesListRedux(clonedPropertiesDataState));
  };

  const handleChildChange = (parentIndex: number, childIndex: number) => {
    const newParents = cloneDeep(propertiesDataState);
    const parent = newParents[parentIndex];
    const child = parent.history[childIndex];
    child.isChecked = !child.isChecked;
    parent.isChecked = parent.history.every((child: any) => child.isChecked);
    dispatch(setPropertiesListRedux(newParents));
  };
  const getChildObject = (property: any, propertiesList: any) => {
    let data: any = [
      {
        content: (
          <Box
            onClick={() => {
              navigate(`/property/${property.inncode}?parentTab=Property+Plans`);
            }}
            sx={{
              textDecoration: "none",
              cursor: "pointer",
              color: tokens.Text.General.PrimaryHeadline,
              fontWeight: "700"
            }}
          >
            {getPropertyName(property)}
          </Box>
        ),
        showBold: true,
        tooltip: {}
      },
      { content: property.inncode },
      { content: property.brandName },
      {
        content: getImplementedPlanCount(view, property),
        tooltip: {
          title: view === "dashboard" ? "" : property.implementedPlansCount,
          list:
            view === "dashboard"
              ? getplanSourceCount(property.implementedPlansCountSourceBreakUp)
              : getAllBreakupLists(property?.implementedPlansCountStatusBreakUp)
        }
      },
      {
        content: view === "dashboard" ? property.managementCompany : property.brandDeadlineInitiativePlansCount,
        tooltip: getBrandOrInitPlanCountStatus(view, property)
      }
    ];

    if (view === "dashboard")
      data.push({
        content: property.ownerGroup
      });

    data.push({ content: property.propertyEngagement, color: getTableColor(property.propertyEngagement) });

    if (view === "myList") {
      data.push({
        content: (
          <BookmarkPlan
            aboveUserPayload={{
              isAboveUsertype: true,
              viewType: abovePropertyViewTypeProperty,
              inncode: property.inncode
            }}
            isBookmarked={bookmarkedProperties?.some((b: any) => b?.innCode === property.inncode)}
            onClickFunction={selectedList?.name === "Bookmarked Properties" ? fetchSummaryAndOverview : () => {}}
          />
        )
      });
    }

    return data;
  };

  useEffect(() => {
    if (listCategory === "consultant" && view === "myList") {
      setPropertiesData(getRowsForSc(propertiesList, selectAllProperties));
    }
  }, [propertiesList]);

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, []);

  const getRowData = (propertiesList: any) => {
    return propertiesList?.map((property: any) => {
      return {
        data: getChildObject(property, propertiesList)
      };
    });
  };

  const getInputDetail = (val: string) => {
    setPageNo(0);
    fetchSummaryAndOverview(0, val, false);
  };

  const handleMemberList = async (value: any) => {
    const clonedPropertiesDataState = cloneDeep(propertiesDataState);
    const memberData = value.map((data: any) => {
      return {
        innCode: isAddUserVisible?.row?.inncode,
        hltId: data.hltId
      };
    });
    const payload = {
      id: selectedList?.id,
      mappings: memberData
    };
    const ress = await dispatch(addMemberToList(payload));
    const index = clonedPropertiesDataState.findIndex(
      (property: any) => property.propertyName === isAddUserVisible?.row?.propertyName
    );
    if (ress?.payload?.status !== responseTypes.error) {
      const mappings = ress.payload?.mappings || [];
      let newMapppings: any;
      if (isAddUserVisible?.row?.isChecked) {
        newMapppings = mappings?.map((child: any) => ({
          ...child,
          isChecked: true
        }));
      } else {
        newMapppings = mappings.map((child: any) => {
          const findmappedHistory = isAddUserVisible?.row?.history?.find(
            (mappedId: any) => mappedId?.mappingId === child?.mappingId
          );
          return { ...child, isChecked: findmappedHistory?.isChecked };
        });
        const unCheckeddMappings: any = [];
        mappings.forEach((data: any) => {
          const findmappedHistory = isAddUserVisible?.row?.history?.find(
            (mappedId: any) => mappedId?.mappingId === data?.mappingId
          );
          if (isUndefined(findmappedHistory) && !isAddUserVisible?.row.checked) {
            unCheckeddMappings.push({ hltId: data.hltId, id: data.mappingId, innCode: data.innCode });
          }
        });
        setUnCheckedMappings([...unCheckedMappings, ...unCheckeddMappings]);
      }
      if (mappings) {
        const { mappingId, hltId } = getAllMapedIdAndUsers(mappings);
        clonedPropertiesDataState[index].inncodeMappingIds = mappingId;
        clonedPropertiesDataState[index].inncodeusers = hltId;
        clonedPropertiesDataState[index].inncodeMappingUserName = hltId[0];
      }
      clonedPropertiesDataState[index].history = newMapppings;
      dispatch(setPropertiesListRedux(clonedPropertiesDataState));

      const extractedUser = setExtractMemberList(clonedPropertiesDataState);
      const userDetails: any = await dispatch(getUserDetails(extractedUser));
      const resPayload = userDetails?.payload?.users || [];
      setAllTeamMember([...resPayload, ...allTeamMember]);
      handleUserVisible({ isVisible: false, selectedInnCode: "", row: null, index: -1 });
    }
  };

  const rowSelection: SelectedListInterface[] = updateSelectedMappingIds(propertiesList);

  return (
    <div
      className={view === "dashboard" ? "dashboard-view-tab-data-component" : "corp-view-tab-data-component"}
      id="propertiesDiv"
    >
      {listCategory === "consultant" && (
        <Feedback
          form=""
          actionStatus={checkInncodeUser}
          message="User is not mapped to some Inncodes that you have selected"
          onCloseChange={() => setCheckInncodeUser({ shouldShow: false, variant: "error", timer: FEEDBACK_TIMER })}
        />
      )}
      <ListKeyMetrics
        view={view}
        listCategory={listCategory}
        keyMetricsData={
          listCategory === "consultant" && view === "myList"
            ? getKeyMetricsPropertiesDataForSc(overview)
            : getKeyMetricsPropertiesData(overview)
        }
      />
      <TableEdit
        view={view}
        selectedListType={selectedListType}
        getInputDetails={(val: string) => getInputDetail(val)}
      />
      <BasicTable
        scrollableTarget="propertiesDiv"
        totalRecords={totalRecords}
        pagination={{ pageNo, setPageNo }}
        noDataMessage={translate("common.noResults")}
        data={{
          headers:
            view === "dashboard"
              ? dashboardPropertiesHeaders
              : listCategory === "consultant" && view === "myList"
              ? scPropertiesHeaders
              : propertiesHeaders,
          rows: getRowData(propertiesList),
          extraData: propertiesDataState,
          listCategory: listCategory === "consultant" && view === "myList"
        }}
        handleUserVisible={(val: any) => handleUserVisible(val)}
        fetchIndividualProperty={fetchIndividualProperty}
        selectAllProperties={selectAllProperties}
        handleSelectedAll={handleSelectedAllScProperty}
        handleParentChange={handleParentChange}
        setId={(id: any) => setId(id)}
        handleChildChange={handleChildChange}
        allTeamMember={allTeamMember}
        setMultiplansAssign={setMultiplansAssign}
        rowSelection={rowSelection}
        selectedList={selectedList}
        handleSetCheckInncodeUser={handleSetCheckInncodeUser}
        view={view}
        setUnCheckedMappings={setUnCheckedMappings}
        unCheckedMappings={unCheckedMappings}
        tableName={tableName}
      />
      {isAddUserVisible.isVisible && (
        <MapUserToInnCode
          isAddUserOpen={isAddUserVisible.isVisible}
          handleClose={() => handleUserVisible({ isVisible: false, selectedInnCode: "", row: null, index: -1 })}
          selectedInnCode={isAddUserVisible?.row?.inncode}
          handleMemberList={handleMemberList}
          innCodeAssignee={assignees}
          isMultiple={true}
        />
      )}

      {multiplansAssign && (selectAllProperties || rowSelection?.length) && (
        <PlanAssignment
          open={multiplansAssign && (selectAllProperties || rowSelection?.length > 0)}
          handleCloseDialog={() => {
            setSelectAllProperties(false);
            setMultiplansAssign(false);
            setPageNo(0);
            fetchSummaryAndOverview(0);
          }}
          flow="second"
          inncodes={
            updateSelectedMappingIds(propertiesList)?.length > 0 &&
            rowSelection?.every(({ innCode }) => innCode === rowSelection[0].innCode)
              ? rowSelection[0]?.innCode
              : DEFAULT_CORP_INNCODE
          }
          scListId={selectedList?.id}
          selectAllProperties={selectAllProperties}
          unCheckedMappings={unCheckedMappings}
          users={rowSelection}
          userSelectionFlow="one"
        />
      )}
    </div>
  );
};
export default React.memo(PropertiesData);
